var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grey darken-3 t-rounded t-shadow standard-step-add mt-1 mb-1",style:(`width: ${_vm.width};`)},[_c('v-icon',{staticClass:"ml-1 mr-1"},[_vm._v("add")]),_c('div',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }